export const useDevelopmentEnvironment = () => {
  const env = import.meta.env.VITE_REACT_APP_STAGE;
  return env !== "production";
};
